export default __webpack_public_path__ + "static/media/neptune3.241488de.png";